import { Injectable } from '@angular/core';
import { faro } from '@grafana/faro-web-sdk';
import { GrafanaConfigurationService } from '../observability/grafana-configuration.service';

@Injectable({
    providedIn: 'root'
})
export class MonitoringService {

    constructor(private readonly _grafanaConfigurationService: GrafanaConfigurationService) 
    {
        
    }
        
    logEvent(name: string, properties?: { [key: string]: any }): void {
        if (this.isGrafanaEnabled()) {
            faro.api.pushEvent(name);
        }
    }
    
    logMetric(name: string, average: number, properties?: { [key: string]: any }): void {
        if (this.isGrafanaEnabled()) {
            faro.api.pushMeasurement({
                type: name,
                values: {
                  duration: average,
                },
            });
        }
    }
    
    logException(exception: Error): void {
        console.error(exception);
        if (this.isGrafanaEnabled()) {
            faro.api.pushError(exception);
        }
    }
    
    logTrace(message: string): void {
        if (this.isGrafanaEnabled()) {
            faro.api.pushLog([message]);
        }
    }

    private isGrafanaEnabled(): boolean {
        return this._grafanaConfigurationService.getConfiguration().isEnabled;
    }
}